/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.copilot.rpc.v2.CopilotCsatService
 */

/**
 * Record for com.hubspot.chirp.core.CausalChainLink
 */

/**
 * Record for com.hubspot.chirp.core.ChirpMethodCoordinates
 */

/**
 *  Request to close a CSAT survey for a specific thread without submitting a response.
 *  Note: portalId and userId are accessed from ChirpContext, not from this request object.
 */

/**
 *  Response to confirm a CSAT survey has been closed
 */

/**
 *  Request to check if a CSAT survey should be sent to a user.
 *  Note: portalId is accessed from ChirpContext, not from this request object.
 */

/**
 *  Response indicating whether a CSAT survey should be sent to a user.
 */

/**
 *  Request to submit a CSAT survey response from a user.
 *  Note: portalId is accessed from ChirpContext, not from this request object.
 */

/**
 *  Response after submitting a CSAT survey, containing the created CSAT entry.
 */

export const shouldSendCsatSurveyRpc = {
  serviceName: 'com.hubspot.copilot.rpc.v2.CopilotCsatService',
  rpcName: 'shouldSendCsatSurvey',
  auth: 'app',
  fingerprint: 'Lz1zhizxXhij13weIgdkXJwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const submitCsatResponseRpc = {
  serviceName: 'com.hubspot.copilot.rpc.v2.CopilotCsatService',
  rpcName: 'submitCsatResponse',
  auth: 'app',
  fingerprint: '7zOAbMs_Wrs-iJQuH1oiFpwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const closeCsatSurveyRpc = {
  serviceName: 'com.hubspot.copilot.rpc.v2.CopilotCsatService',
  rpcName: 'closeCsatSurvey',
  auth: 'app',
  fingerprint: 'MjlnqYkmaM2vhjQsoMw5B5wP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};